import React from "react";

import "./MyAccountInformation.style.scss"
import useDeviceType from "../../hooks/useDeviceType";
import {FormattedMessage} from "react-intl";

const MyAccountInformation = ({vm}) => {
    const {isMobile} = useDeviceType();

    return (
        <div className="MyAccountInformation">
            <h2 className="myAccountInfoTitle">
                <FormattedMessage id={"myAccountView.myProfile.accountInformationTitle"}/>
            </h2>
            <form onSubmit={vm.handleInfoSubmit}>
                <div className="formGroup">
                    <label className="label"><FormattedMessage id={"myAccountView.myProfile.userName"} /></label>
                    <input
                        className={vm.infoErrors.pseudonym ? 'input inputError' : 'input'}
                        type="text"
                        name="pseudonym"
                        value={vm.userData?.pseudonym}
                        onChange={vm.handleUserDataChange}
                    />
                    {vm.infoErrors.pseudonym && <div className="errorText">
                        <FormattedMessage id={"myAccountView.myProfile.userNameRequired"}/>
                    </div>}
                </div>

                <div className="formGroup">
                    <label className="label">
                        <FormattedMessage id={"myAccountView.myProfile.firstName"} />
                    </label>
                    <input
                        className={vm.infoErrors.firstName ? 'input inputError' : 'input'}
                        type="text"
                        name="firstName"
                        value={vm.userData?.firstName}
                        onChange={vm.handleUserDataChange}
                    />
                    {vm.infoErrors.firstName && <div className="errorText">
                        <FormattedMessage id={"myAccountView.myProfile.firstNameRequired"}/>
                    </div>}
                </div>

                <div className="formGroup">
                    <label className="label">
                        <FormattedMessage id={"myAccountView.myProfile.lastName"} />
                    </label>
                    <input
                        className={vm.infoErrors.lastName ? 'input inputError' : 'input'}
                        type="text"
                        name="lastName"
                        value={vm.userData?.lastName}
                        onChange={vm.handleUserDataChange}
                    />
                    {vm.infoErrors.lastName && <div className="errorText">
                        <FormattedMessage id={"myAccountView.myProfile.lastNameRequired"}/>
                    </div>}
                </div>

                <div className="formGroup">
                    <label className="label">
                        <FormattedMessage id={"myAccountView.myProfile.email"} />
                    </label>
                    <input
                        className={vm.infoErrors.email ? 'input inputError' : 'input'}
                        type="email"
                        name="email"
                        value={vm.userData?.email}
                        onChange={vm.handleUserDataChange}
                    />
                    {vm.infoErrors.email && <div className="errorText">
                        <FormattedMessage id={"myAccountView.myProfile.emailRequired"}/>
                    </div>}
                </div>



                <button type="submit"
                        className="button"
                        style={{display: "none"}}
                >
                    Submit
                </button>
            </form>
        </div>
    );
}

export default MyAccountInformation;